<template>
    <div class="ur-data-grid__content__cell" ref="td"
            :style="tdStyle" :class="tdClass"
            @mousedown="pdn" @mouseover="mup"
            @contextmenu="onContextMenu" 
            @click="onClickCell" @dblclick="onEditCell">
        <!-- XXX keep ORDER! -->
        <!-- Case.1 : is Hided -->
        <template v-if="isHide"/>
        <!-- Case.2 : Edit Cell -->
        <!-- Case.2-1 : Edit Cell + Row mode + Custom Compo -->
        <cell-edit-compo v-else-if="isOnEdit && isEditCompo"
                         :field="field" :value="editValue" :text="showText"
                         @applyRule="applyRule(3)" @resetRule="resetRule"/>
        <!-- Case.2-2 : Edit Cell - Row mode -->
        <cell-edit v-else-if="isOnEdit && !isEditCompo"
                   :field="field" :value="editValue"
                   @applyRule="applyRule(3)" @resetRule="resetRule"/>
        <!-- Case.3 : Custom component /w read-mode -->
        <cell-compo v-else-if="isCompo"
                :field="field" :value="value" :text="showText"/>
        <!-- Case.x : Default Cell -->
        <cell-value v-else :field="field" :text="showText"/>
    </div>
</template>

<script>
import cellValue     from './sub/urDataGridContentCellValue.vue';
import cellCompo     from './sub/urDataGridContentCellCompo.vue';
import cellEdit      from './sub/urDataGridContentCellEdit.vue';
import cellEditCompo from './sub/urDataGridContentCellEditCompo.vue';
import {dateToText, convNumberFormat}  from '../../util'
//--------------
import validMixin   from "./mixin/urDataGridContentCellValidMixin.js";
import styleMixin   from "./mixin/urDataGridContentCellStyleMixin.js";
import contextMixin from "./mixin/urDataGridContentCellContextMixin.js";
//--------------
const isIE = /*@cc_on!@*/false || !!document.documentMode;

/**************************************************
 * Contents Cell
 *     - Sell Positioning
 *     - Decide view value type : EDIT, (*)NORMAL
 *************************************************/
export default {
    name : 'urDataGridContentCell',
    mixins : [validMixin, styleMixin, contextMixin],
    inject : ['gridInfo', 'rowInfo'],
    components: {
        cellValue,
        cellCompo,
        cellEdit,
        cellEditCompo
    },
    props : {
        field : {type:Object},
        value : null /* type any */,
    },
    computed: {
        // ------------------------------------------------
        // ------ [COMPUTED] Flag
        // [COMPUTED] Flag, Is on edit? [cell]
        isCellEdit() {
            return this.gridInfo.opts.cellEdit
                && this.isEditable
                && this.rowInfo.row.__editField === this.field.value;
        },
        // [COMPUTED] Flag, Is on edit? [row]
        isRowEdit() {
            if(!this.gridInfo.opts.rowEdit) return false;
            if(!this.rowInfo.row.__editMode) return false;
            return this.isEditable;
        },
        // [COMPUTED] Flag, Is cell editable?
        isEditable() {
            // EDIT OPTIONS IS NOT SET.
            if (this.isOptsEdit) return false;
            if (this.rowInfo.row.__dirty === this.gridInfo.CONST.VAL.DIRTY.FLAG.CREATE) {
                // On create row
                let isReadonly = !!this.field.readolny;
                if(typeof this.field.readonly === 'function') {
                    isReadonly = this.field.readonly(this.value, this.rowInfo.row, this.field);
                }
                return !isReadonly
                
            } else {
                // On update row
                let isReadonly = !!this.field.readolny;
                if(typeof this.field.readonly === 'function') {
                    isReadonly = this.field.readonly(this.value, this.rowInfo.row, this.field);
                }
                if(isReadonly) {return false}
                else if(typeof this.field.edit === 'function') {
                    return this.field.edit(this.value, this.rowInfo.row, this.field)
                } else {
                    return !!this.field.edit
                }
            }
        },
        isOptsEdit() {return !this.gridInfo.opts.rowEdit && !this.gridInfo.opts.cellEdit},
        // [COMPUTED] Flag, Is on edit?
        isOnEdit()    {return !!this.isCellEdit || !!this.isRowEdit},
        // [COMPUTED] Flag, Is hided cell?
        isHide()      {return !!this.field.hide || !!this.isMergeHide;},
        // [COMPUTED] Flag, Is custom component?
        isCompo()     {return !!this.field.component},
        // [COMPUTED] Flag, Is custom component?
        isEditCompo() {return !!this.field.editComponent},
        // [COMPUTED] Flag, Is Merged cell?
        isMerged() {
            return this.gridInfo.opts.groupMerge &&
                   this.field.__isGroup>=0 &&
                   this.rowInfo.groupHeight &&
                   this.rowInfo.groupHeight[this.field.__isGroup];
        },
        // [COMPUTED] Flag, Is hided by other merged cell?
        isMergeHide() {
            return this.gridInfo.opts.groupMerge &&
                   this.field.__isGroup>=0 &&
                   (!this.rowInfo.groupHeight || !this.rowInfo.groupHeight[this.field.__isGroup])
        },
        // [COMPUTED] Flag, Is clickable cell?
        isClick() {
            return !!this.field.click && typeof this.field.click === 'function'
        },
        // ------------------------------------------------
        // ------ [COMPUTED] Value
        // [COMPUTED] Value, Text for show
        showText() {
            var cv = this.field.customValue, v = this.value;
            if(cv && typeof cv ==='function') {
                return cv(v, this.rowInfo.row, this.gridInfo.caller);
            }
            switch(this.field.type) {
            case 'date':
                // Empty
                if(!v) {return ''}
                // Number, String, Date
                var fmt = this.field.dateFormat || this.gridInfo.opts.dateFormat;
                return dateToText(v, fmt, this.timezone);
            case 'code':
                if(this.field.__domainMap) {
                    var dobj = this.field.__domainMap.get(v);
                    return dobj?dobj.text:v;
                } else {
                    return v;
                }
            case 'number':
                if(v===null||v===undefined) return ''
                return convNumberFormat(v, this.field.numberFormat || this.gridInfo.opts.numberFormat)
            default:
                // NO OP
            }
            return v;
        },
        // [COMPUTED] Value, Value for edit/validate
        editValue() {
            if(this.isRowEdit) {
                return this.gridInfo.vars_currEditRow[this.field.value]
            } else if (this.isCellEdit) {
                return this.gridInfo.vars_cTempValue;
            } else {
                return this.value;
            }
        },
        // [COMPUTED] Value, timezone
        timezone() {return this.field.timezone === null ? this.gridInfo.opts.timezone : this.field.timezone}
    },
    watch: {
        isOnEdit(v,w) {
            // 1. Remove error message
            // urDataGridContentCellValidMixin.js
            //     TODO 여기가 맞을까? "모든" 케이스 분석?
            if(!v && w) this.resetRule();
        },
        isCellEdit(v,w) {
            // 1. Set focus & Make cell temp value
            if(v && !w) {
                // 1.1 Start edit
                this.focus();
            }
        }
    },
    beforeDestroy() {
        if(this.isCellEdit) {
            this.gridInfo.func.cancelCell();
        }
    },
    methods: {
        // [METHODS] Util : Focus on tab
        tabFocus() {
            this.gridInfo.refs.table.focus();
        },
        // [METHODS] Event : Click cell
        onClickCell(e) {
            if(this.isClick) {
                this.field.click(this.value, this.rowInfo.row, this.field, e);
            }
        },
        // [METHODS] Event : on-Edit cell ~ start cell edit
        onEditCell() {
            // 1. Check first
            if(!this.gridInfo.opts.cellEdit) return;
            if(this.gridInfo.vars_cSelOnEdit) return;
            // 2. Open edit second
            this.gridInfo.func.editCell();
        },
        // [METHODS] Event : Pointer down
        pdn(e) {
            // 1. Cell select mode
            if(this.gridInfo.opts.cellMode) {
                // 1.1 set position
                const idx = this.rowInfo.idx, field = this.field;
                if(this.gridInfo.vars_cSelOnEdit) {
                    var res = this.gridInfo.func.saveCell();
                    if(!res) return;
                }
                this.gridInfo.func.startCellSelect(idx, field);
                this.gridInfo.func.endCellSelect(idx, field);
                // 1.2 Init drag event.
                document.body.onmouseup   = this.pup;
            }
            
            // 2. Fire grid event.
            this.gridInfo.func.fireEvent('click', this.value, this.rowInfo.row, this.field, e);
        },
        // [METHODS] Event : Mouse up
        mup(e) {
            if(this.gridInfo.vars_cSelOnDrag) {
                // TODO add condition? or doesn't need? -> onDrag also include opts.cellMode
                this.gridInfo.func.endCellSelect(this.rowInfo.idx, this.field);
            }
        },
        // [METHODS] Event : Pointer up - Temporal, Body
        pup(e) {
            // 1. finish drag
            this.gridInfo.func.finishCellDrag();
            // x. Release drag event.
            document.body.onmouseup = null;
        },
        // [METHODS] Function : Focus element when editable & onEdit
        focus(flag) {
            if(this.isOnEdit) {
                this.$nextTick(()=>{
                    var comp = this.$children[0];
                    if(comp && comp.focus) {
                        // [ARG]flag : Focus makes scroll. (no opts)
                        if(flag) {
                            comp.focus();
                        } else if(isIE) { // && !flag
                            var prevScroll = this.gridInfo.refs.scrollWrapper.scrollTop
                            comp.focus();
                            requestAnimationFrame(()=>{
                                this.gridInfo.eventBus.$emit('set-scroll-top',prevScroll)
                            })
                        } else { // !isIE && !flag
                            var opts = {preventScroll:true}
                            comp.focus(opts);
                        }
                    }
                    // Select text all
                    if(comp && comp.selectAll) {
                        comp.selectAll();
                    }
                })
                return true;
            } else {
                // Is not an edit cell?
            }
            return false;
        },
        // [METHODS] Function : Some logic for cell
        cellErrMessage(msg) {
            this.setMessage(msg);
        }
    }
}

</script>

